import script from "./SightseeingTour.vue?vue&type=script&setup=true&lang=js"
export * from "./SightseeingTour.vue?vue&type=script&setup=true&lang=js"

import "./SightseeingTour.vue?vue&type=style&index=0&id=2544906f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2544906f"]])

export default __exports__